// export const BASE_URL = "http://localhost:5001";
// export const BASE_URL_PUBLISHING_API = "http://localhost:8080";
// export const BASE_URL_HERES_AMERICA = "http://localhost:3000/api"; //LOCAL

// export const BASE_URL_HERES_AMERICA = "https://dpi-academy.vercel.app/api";
export const BASE_URL_HERES_AMERICA = "https://www.thedreamersland.com/api";
// export const BASE_URL_HERES_AMERICA = "http://localhost:3000/api";

export const BASE_URL_PUBLISHING_API = "https://publishing.dpi-api.com";

export const BASE_URL = "https://dpi-api.com";
// export const BASE_URL = "http://localhost:5001";

export const READER_BASE_URL = "https://dpireader.com";
// export const READER_BASE_URL = "http://localhost:3001";
